const NS = 'FlipCardContainerBlock';
const CLS = 'flipCardContainerBlock';

import { compactViewMixinBlock } from '../../mixins/compactViewMixinBlock/compactViewMixinBlock';
import { fullWindowHeightMixinBlock } from '../../mixins/fullWindowHeightMixinBlock/fullWindowHeightMixinBlock';
import { trackingItemsMixinBlock } from '../../mixins/trackingItemsMixinBlock/trackingItemsMixinBlock';

export class FlipCardContainerBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$flipCards = this.$element.find('.flipCardTileBlock');

		if(this.$element.hasClass(`${CLS}--portrait`)) {
			this.$flipCards.addClass('flipCardTileBlock--portrait');
		}
		else if(this.$element.hasClass(`${CLS}--landscape`)) {
			this.$flipCards.addClass('flipCardTileBlock--landscape');
		}

		this.initCompactView(this);
		this.initFullWindowHeight(this);
		this.initTrackingItems(this, this.$flipCards);

		this.$element.find(`.${CLS}-tiles`).css({
			visibility: 'visible'
		});
	}
}

Object.assign(FlipCardContainerBlock.prototype, compactViewMixinBlock);
Object.assign(FlipCardContainerBlock.prototype, fullWindowHeightMixinBlock);
Object.assign(FlipCardContainerBlock.prototype, trackingItemsMixinBlock);
